import React, { useEffect, useState } from 'react';
import driverApi from '../../../clients/DriverClient';
import { useBookingContext } from '../BookingContext';
import { useAuth } from '../../../context/AuthContext';
import ButtonSelect from '../../shared/ButtonSelect';
import { formatLocation } from '../../../utils/bookingUtils';

const LocationSection: React.FC = () => {
  const { booking, updateBooking } = useBookingContext();
  const { user } = useAuth();
  const [locations, setLocations] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadLocations = async () => {
      setIsLoading(true);
      setError('');
      try {
        const result = await driverApi.getBookingLocations();

        setLocations(result);
        if (!booking.location && result.length > 0) {
          updateBooking({ location: user?.preferredLocation || result[0] });
        }
      } catch (e) {
        setError('Failed to load locations');
      } finally {
        setIsLoading(false);
      }
    };

    loadLocations();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
      <div className="mb-3">
       <ButtonSelect
        options={locations}
        selected={booking.location}
        onChange={(location) => updateBooking({ location })}
        disabled={isLoading}
        title="Locations:"
        renderLabel={formatLocation}
       />
        {error && <div className="text-danger mt-2">{error}</div>}
      </div>
  );
};

export default LocationSection;
